import { BaseFileModel } from '../data';

export interface WhatsAppFilesPayloadModel {
  files: BaseFileModel[];
}
